<template>
    <div>
        <grid class="c-m g-m" v-if="!!objectTree && objectTree.idx > -1">
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.group_label')}}</b>
                </column>
                <column :xs="7">
                    <label class="dock-pull-select-label">
                        <select class="dock-pull-select" name="group_id" v-model="selectedGroup">
                            <option v-for="group in groups" :key="group.id" :value="group">{{group.name}}</option>
                        </select>
                    </label>
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.contract_num_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="contract" :value="objectTree.obj.contract" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.mark_label')}}</b>
                </column>
                <column :xs="7">
                    <label class="dock-pull-select-label">
                        <select class="dock-pull-select" name="mark" v-model="objectTree.obj.mark">
                            <option v-for="(mark, key) in marks" :key="key">{{mark}}</option>
                        </select>
                    </label>
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.model_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="model" :value="objectTree.obj.model" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.year_label')}}</b>
                </column>
                <column :xs="7">
                    <label class="dock-pull-select-label">
                        <select class="dock-pull-select" name="year" v-model="objectTree.obj.year">
                            <option v-for="(year, key) in years" :key="key">{{year}}</option>
                        </select>
                    </label>
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.vin_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="vin" :value="objectTree.obj.vin" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.pts_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="pts" :value="objectTree.obj.pts" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.org_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="org_name" :value="objectTree.obj.org_name" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.full_name_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="full_name" :value="objectTree.obj.full_name" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.contact_num_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="contact" :value="objectTree.obj.contact" @input="updateValue">
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.inst_place_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="inst_site" :value="objectTree.obj.inst_site" @input="updateValue" readonly>
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.installer_fn_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" type="text" name="full_name_inst" :value="objectTree.obj.full_name_inst" @input="updateValue" readonly>
                </column>
                <column :xs="1"></column>
            </row>
            <row class="c-m" :reverse="!1" start="xs" middle="xs">
                <column :xs="4">
                    <b>{{$t('devices.inst_date_label')}}</b>
                </column>
                <column :xs="7">
                    <b>{{objectTree.obj.dt_install | moment($t('date_format'))}}</b>
                </column>
                <column :xs="1"></column>
            </row>
        </grid>
        <div v-else>
            <div class="item">
                <div class="dock-pull-list-text">
                    <div class="dock-pull-list-header">
                        <h3>{{$t('devices.single.not_found_label')}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'DeviceOptions',
  computed: {
    ...mapGetters({
      getObjTree: 'getObjectFromTree',
      groups: 'getGroupsFromTree',
      marks: 'getMarks'
    }),
    objectTree () {
      return this.getObjTree(this.$route.params.id)
    },
    selectedGroup: {
      get () {
        return {
          id: this.objectTree.obj.group_id,
          idxg: this.objectTree.idxg,
          name: this.objectTree.obj.group
        }
      },
      set (n) {
        this.changeGroup({
          ...n,
          idx_old: this.objectTree.idx,
          idxg_old: this.objectTree.idxg
        })
      }
    },
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1900}, (value, index) => year - index)
    }
  },
  methods: {
    ...mapActions(['updateObject', 'changeGroup']),
    updateValue (e) {
      this.updateObject({
        idx: this.objectTree.idx,
        idxg: this.objectTree.idxg,
        value: e.target.value,
        param: e.target.name
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/devices/active/DeviceOptions.vue